module.exports = __webpack_public_path__ + "static/media/vip-trophy-1.5b303287.png";